<template lang="html">
  <div
    class="flex items-center pl1"
    style="border-bottom: 1px solid rgba(0, 0, 0, 0.12)"
  >
    <div
      class="flex ma3"
      :class="{ 'toggle-side-bar': hovered }"
      @mouseenter="hovered = true"
      @mouseleave="hovered = false"
      @click="toggleSideBarVisibility"
    >
      <div class="customize-tooltip">
        <img
          v-if="!hovered && !getCourseLayoutFullScreenStatus"
          src="/static/logos/collapse_black.svg"
          alt="hide"
        />
        <img
          v-else-if="hovered && !getCourseLayoutFullScreenStatus"
          src="/static/logos/collapse_blue.svg"
          alt="hide"
        />
        <img
          v-else-if="!hovered && getCourseLayoutFullScreenStatus"
          src="/static/logos/expand_black.svg"
          alt="hide"
        />
        <img v-else src="/static/logos/expand_blue.svg" alt="hide" />
        <div v-if="hovered">
          {{ getCourseLayoutFullScreenStatus ? 'expand' : 'collapse' }}
        </div>
      </div>
    </div>
    <div
      class="flex items-center ml2"
      style="flex: 3; height: 100%; max-width: 60%"
    >
      <edit-title-inline />
    </div>
    <div class="live-discussion-optional-btn-row flex" style="flex: 1">
      <div class="flex flex-nowrap items-center" style="margin-left: auto">
        <point-descriptions
          class="pl-subheading dib"
          v-if="
            getCurrentDiscussion.points_settings.peer_rewards.length &&
            !hasTeacherPermissionsInCourse
          "
          :rewards="getCurrentDiscussion.points_settings.peer_rewards"
          :criteriaScale="Number(getCurrentDiscussion.point_cap)"
        />
        <div
          v-if="showQuestionIcon"
          @click="$emit('showRountableWelcomeModal')"
          class="clickable firstRT-welcome-tutorial"
        >
          <i class="fa fa-question"></i>
        </div>

        <pl-button
          v-if="hasTeacherPermissionsInCourse"
          @click.native="$emit('showShareActivityModal')"
          class="invite-button-custom pv1 clickable ripple mr2 flex items-center nav-rt-button"
        >
          INVITE
        </pl-button>
        <pl-button
          v-if="hasTeacherPermissionsInCourse"
          @click.native="$emit('goToSummaryPage')"
          class="summary-button pv1 clickable ripple mr2 flex items-center nav-rt-button"
        >
          SUMMARY
        </pl-button>
        <!-- NOTE: This is is the fullscreen button. It has been removed -->
        <!-- <pl-button
          style="margin-right: 0"
          class="pl-secondary-font pl-icon nav-bar-btn"
          @click.native="$emit('toggleCourseSideBarVisibility')" >
          <img :src="getCourseLayoutFullScreenStatus ? '/static/minimize.svg' : '/static/fullscreen.svg'" alt="avatar">
        </pl-button> -->
        <pl-menu
          v-if="hasTeacherPermissionsInCourse"
          :menuSize="5"
          direction="right"
        >
          <pl-button
            slot="menu_trigger"
            class="pl-icon nav-bar-btn"
            style="margin: 0 16px"
          >
            <i class="fas fa-ellipsis-v"></i>
          </pl-button>
          <ul menu-content>
            <li @click="addToUniverse">
              <span>Add to Universe</span>
              <img
                src="/static/logos/universe_logo.svg"
                alt=""
                class="ml1"
                style="width: 16px"
              />
            </li>
            <li @click="show_export_data_modal = true">
              <span>Export Data</span>
              <i class="fa fa-download"></i>
            </li>
            <li @click="showDuplicateModal">
              <span> Duplicate RoundTable </span>
              <i class="fa fa-files-o"></i>
            </li>
            <li @click="openSentencesStemsSettings()">
              <span>Edit Sentence Stems</span>
              <img src="/static/ld-sentence-stems.svg" />
            </li>
            <li @click="$emit('editAssessment')">
              <span>Edit Assessment Criteria</span>
              <i class="fa fa-gear"></i>
            </li>
            <li @click="syncAssessment">
              <span> Sync Assessment </span>
              <img src="/static/sync.svg" />
            </li>
            <li
              @click="show_delete_live_rt_modal = true"
              style="color: #e53935"
            >
              <span>Delete Discussion</span>
              <i class="fa fa-trash"></i>
            </li>
          </ul>
        </pl-menu>
      </div>
    </div>
    <pl-confirm
      v-if="show_delete_live_rt_modal"
      confirmColor="bg-red-500"
      confirmText="DELETE"
      @close="show_delete_live_rt_modal = false"
      @confirm="deleteLiveRoundtable"
    >
      <div class="ma4 tl ph4 pl-subheading">
        <p class="ma0">
          You are deleting <strong>{{ getCurrentDiscussion.title }}.</strong>
        </p>
        <p class="pl-body-1 ma0 italics">
          This cannot be undone and student data will be lost forever.
        </p>
      </div>
    </pl-confirm>

    <!-- Goodle Drive / Data exporting Modal -->
    <ExportEngagementDataModal
      :fileName="exportable_file_name"
      :getFile="fetchClassCSVdata"
      :showButtons="Boolean(getCurrentDiscussion.participations.length)"
      @close="show_export_data_modal = false"
      v-if="show_export_data_modal"
    />

    <!-- This is the modal where teachers will edit the questions modal -->
    <pl-dialog
      v-if="show_guiding_questions_modal"
      @close="show_guiding_questions_modal = false"
    >
      <pl-button
        class="pl-icon"
        style="position: absolute; top: 0; right: 0"
        @click.native="show_guiding_questions_modal = false"
      >
        <i class="fa fa-close"></i>
      </pl-button>
      <div class="pl-title">
        <strong>Guiding Questions</strong>
      </div>
      <div class="pl-caption mb4">(seen on student notepad)</div>

      <!-- Guiding Questions Container -->
      <div
        ref="guiding_questions_container"
        class="mt3 tl guiding-questions-container"
      >
        <div
          v-for="(question, index) in getCurrentDiscussion.guiding_questions"
          style="position: relative"
          class="mv3 pl-subheading"
        >
          <div style="overflow-wrap: break-word" class="">
            {{ index + 1 }}. {{ question }}
          </div>
          <pl-button
            @click.native="deleteGuidanceQuestion(index)"
            class="pl-icon"
            style="position: absolute; right: -30px; top: 0; margin-top: -5px"
          >
            <i class="fa fa-close"></i>
          </pl-button>
        </div>
      </div>
      <!-- Create new Guiding Question -->
      <div>
        <div class="row middle-xs center-xs">
          <pl-input
            type="text"
            labelText=""
            :maxLength="255"
            v-model="new_guiding_question"
            class="col-xs-8"
          />
          <pl-button
            class="pl-primary pl-icon"
            @click.native="createNewGuidingQuestion"
          >
            <i class="fa fa-plus" aria-hidden="true"></i>
          </pl-button>
        </div>
      </div>
    </pl-dialog>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import getWelcomeSettings from 'services/account/getWelcomeSettings';
  import EditTitleInline from './editTitleInline.liveDiscussion';
  import generateExportableData from 'services/liveDiscussion/generateExportableData';
  import ExportEngagementDataModal from 'components/modals/exportEngagementDataModal';
  import PointDescriptions from 'components/pointDescriptions.vue';
  import entryOptions from 'features/onlineRoundtables/components/entryOptions/entryOptions.vue';
  import moment from 'moment';
  import { EventBus } from 'utils/event-bus';

  import LiveDiscussionService from 'services/liveDiscussion';
  import authenticationService from 'features/authentication/authentication.services';

  import URLconfigs from 'services/apiConfigs';

  export default {
    data() {
      return {
        show_delete_live_rt_modal: false,
        show_export_data_modal: false,
        hovered: false,
        show_guiding_questions_modal: false,
        showQuestionIcon: false,
        new_guiding_question: '',
      };
    },
    components: {
      EditTitleInline,
      ExportEngagementDataModal,
      entryOptions,
      PointDescriptions,
    },
    computed: {
      ...mapGetters([
        'getCourseLayoutFullScreenStatus',
        'hasTeacherPermissionsInCourse',
        'getCurrentDiscussion',
      ]),
      exportable_file_name() {
        const date = moment().format('L'); // MM-DD-YYYY
        const fileName = `${this.getCurrentDiscussion.title} - Live - Export ${date}.csv`;
        return fileName;
      },
    },
    props: {
      showSideBar: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      toggleSideBarVisibility() {
        this.$store.commit(
          'CHANGE_FULL_SCREEN_ON_COURSE_LAYOUT',
          !this.getCourseLayoutFullScreenStatus
        );
        this.$store.commit('SHOW_SLIDING_HIDDEN_ROUNDTABLE_LIST', true);
        this.$emit('exitFullScreen');
      },
      showWelcomeSettings() {
        EventBus.$emit('showLiveRountableWelcomeModal');
      },
      syncAssessment() {
        EventBus.$emit('rtIntegrationAssignment', true);
      },
      showRTWelcomeModalQuestionIcon() {
        getWelcomeSettings
          .getSettingsByQuery('live')
          .then((welcomeSettings) => {
            let settings;
            // If the user is a teacher.
            if (this.hasTeacherPermissionsInCourse) {
              settings = welcomeSettings.find((s) => s.role === 'teacher');
            } else {
              settings = welcomeSettings.find((s) => s.role === 'student');
            }

            if (settings.enabled) {
              this.showQuestionIcon = true;
            }
          });
      },
      fetchClassCSVdata() {
        // Make request for data here
        return generateExportableData(this.getCurrentDiscussion.id).then(
          (res) => res.data
        );
      },
      createNewGuidingQuestion() {
        if (!this.new_guiding_question) {
          return;
        }

        const guiding_questions = [
          ...this.getCurrentDiscussion.guiding_questions,
          this.new_guiding_question,
        ];

        this.$store
          .dispatch('saveLiveDiscussionSettings', {
            guiding_questions,
            id: this.getCurrentDiscussion.id,
          })
          .then(() => {
            this.new_guiding_question = '';
            this.$refs.guiding_questions_container.scrollTop =
              this.$refs.guiding_questions_container.scrollHeight;
          });
      },
      deleteGuidanceQuestion(index) {
        const guiding_questions = [
          ...this.getCurrentDiscussion.guiding_questions,
        ];

        guiding_questions.splice(index, 1);

        this.$store.dispatch('saveLiveDiscussionSettings', {
          guiding_questions,
          id: this.getCurrentDiscussion.id,
        });
      },
      deleteLiveRoundtable() {
        this.$store.dispatch('deleteDiscussion', {
          id: this.getCurrentDiscussion.id,
          rtPage: true,
        });
      },
      showDuplicateModal() {
        this.$emit('showDuplicateModal');
      },
      openSentencesStemsSettings() {
        EventBus.$emit('editSentenceStems');
      },
      addToUniverse() {
        LiveDiscussionService.addLiveDiscussionToUniverse(
          this.getCurrentDiscussion.id
        )
          .then((res) => {
            const payload = {
              id: this.getCurrentDiscussion.id,
              meta: { premade_id: res.data },
              created_universe_premade: true,
            };

            this.$store.dispatch('saveLiveDiscussionSettings', payload);

            const live_discussion_url = `${URLconfigs.universeURL}/live_discussions/${res.data}`;

            authenticationService.navigateToExternalWithAuth(
              live_discussion_url
            );
          })
          .catch((e) => {
            console.error(e);
            EventBus.$emit(
              'toast-msg',
              'Something went wrong, please refresh!'
            );
          });
      },
    },
    mounted() {
      this.showRTWelcomeModalQuestionIcon();
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl';
  @import '~app/global-stylus'

  .nav-bar-btn:hover
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.2)

  .data-icon-pie
    height: 30px
    min-height: 30px
    min-width: 35px

  .firstRT-welcome-tutorial
    padding-right: 12px;
  .live-discussion-optional-btn-row
    .summary-button
      background-color: #f4fcfc
      color: pl-primary
      border: 2px solid pl-primary
      margin-right: 0px;
      &&:hover
        background: white

    .invite-button-custom
      color: #157F1F
      border: 2px solid #157F1F
      background-color:#f6faf5

  .guiding-questions-container
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    max-height: 550px;
    overflow-y: scroll;
    padding-right: 70px;
    padding-left: 60px;
    margin-bottom: 20px;

  ::-webkit-scrollbar
    display: inline
    width: unset
    -webkit-appearance: unset

  .customize-tooltip
    img
      cursor: pointer
    div
      box-shadow: 0 0 4px 2px rgba(0,0,0,.2)
      position: absolute
      width: 70px
      color: #43484c
      background-color: #fff
      border-radius: 5px
      padding: 5px
      margin-left: -18px
      margin-top: 7px
      font-size: 12px
      font-weight: 600
      z-index: 2
  .customize-tooltip div:before{
    content: " ";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent white transparent;
  }
</style>



// WEBPACK FOOTER //
// discussionCircleNavBar.vue?649b3a5a